import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-code">404</div>
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <div className="not-found-actions">
          <button className="btn btn-primary btn-large" onClick={() => navigate('/')}>
            <i className="fas fa-home"></i>
            Back to Home
          </button>
          <button className="btn btn-secondary btn-large" onClick={() => navigate('/#contact')}>
            <i className="fas fa-envelope"></i>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
